import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '@services/token-service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a[lvLogout], button[lvLogout]'
})
export class LogoutDirective {
  private tokenService = inject(TokenService);
  private router = inject(Router);

  @HostListener('click') click() {
    this.tokenService.signOut().subscribe(
      () => this.router.navigateByUrl('auth/sign_in'),
      (err) => console.error(err)
    );
  }
}
